import { User } from './user';
import { UnitRoom, UnitRoomActivity } from './unitRoom';
import { Message } from './message';

export class ChatCommand {
  command: string;

  constructor(command: string) {
    this.command = command;
  }
}

export class ChatCommandJoin extends ChatCommand {
  unit_room: number;
  user: User;

  constructor(unit_room: number) {
    super('join');
    this.unit_room = unit_room;
  }
}

export class ChatCommandLoad extends ChatCommand {
  title: string;
  unit_room: UnitRoom;
  messages: Message[];
  previous: number;
  next: number;
  reached_end: boolean;

  constructor() {
    super('load');
  }
}

export class ChatCommandLoadMore extends ChatCommand {
  unit_room: number;
  user: number;
  previous: number;
  next: number;
  reached_end: boolean;
  messages: Message[];

  constructor(previous: number, next: number, unit_room: number) {
    super('load_more');
    this.previous = previous;
    this.next = next;
    this.unit_room = unit_room;
  }
}

export class ChatCommandTyping extends ChatCommand {
  unit_room: number;
  user: User;
  status: string;

  constructor(unit_room: number, status: string) {
    super('typing');
    this.status = status;
    this.unit_room = unit_room;
  }
}

export class ChatCommandUnitRoomActivity extends ChatCommand {
  unit_room: number;
  unit_room_activities: UnitRoomActivity[];

  constructor(unit_room: number, unit_room_activities: UnitRoomActivity[]) {
    super('unit_room_activity');
    this.unit_room_activities = unit_room_activities;
    this.unit_room = unit_room;
  }
}

export class ChatCommandSend extends ChatCommand {
  unit_room: number;
  message: Message;

  constructor(unit_room: number, message: Message) {
    super('send');
    this.message = message;
    this.unit_room = unit_room;
  }
}

export class ChatCommandLeave extends ChatCommand {
  unit_room: number;
  user: User;

  constructor(unit_room: number, user: User) {
    super('leave');
    this.user = user;
    this.unit_room = unit_room;
  }
}
